<template>
  <input type="button" class="btn create" value="新規作成" @click="clickBtnCreate">
</template>

<script>
// import axios from "axios";

export default {
  name: 'BtnCreate',
  props: ['path'],
  methods: {
    clickBtnCreate: function(){
      console.log(this.path)
      this.$router.push(this.path)
      },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.create {
  display: flex;
  justify-content: flex-end;
}

</style>
